export default __webpack_public_path__ + "static/media/TourModalBraulio.89f6bf3d.svg";